"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonDialog = void 0;
var react_1 = __importDefault(require("react"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var CommonDialog = function (_a) {
    var _b;
    var sections = _a.sections, props = __rest(_a, ["sections"]);
    return (react_1.default.createElement(Dialog_1.default, __assign({}, props, { className: "common-dialog", maxWidth: "xs", fullWidth: true }),
        react_1.default.createElement(DialogContent_1.default, null,
            react_1.default.createElement("div", { className: "color-divider" }),
            react_1.default.createElement("div", { className: "dialog-content" }, sections.content)),
        react_1.default.createElement(DialogActions_1.default, { className: "dialog-footer-section" }, (_b = sections === null || sections === void 0 ? void 0 : sections.footer) === null || _b === void 0 ? void 0 : _b.children)));
};
exports.CommonDialog = CommonDialog;
//# sourceMappingURL=CommonDialog.js.map